import { render } from "./PwaInstallButton.vue?vue&type=template&id=0869be12"
import script from "./PwaInstallButton.vue?vue&type=script&lang=js"
export * from "./PwaInstallButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__